import { Grid } from "@material-ui/core";
import DropdownFilter from "components/DropdownFilter";
import LotsDropdown from "components/SharedDropdowns/LotsDropDown";
import { useGetClientsQuery } from "features/clients/clientSlice";
import { useGetLotsQuery } from "features/lots/lotSlice";
import { useDispatch, useSelector } from "react-redux";
import { userHasOneClient } from "features/user/userSlice";
import { loadsDashboardStyles } from "./style";
import { setFilters } from "./loadsDashboardSlice";
import { useGetClientTransportersQuery, useGetTransportersQuery } from "features/transporter/transporterSlice";
import { getDateFilterRanges, dateFilterTypesList, loadDistanceList } from "./loadsDashboardConsts";
import _, { groupBy } from "lodash";
import { useGetClientsWithConfigsQuery } from "features/clients/clientConfigSlice";
import { arrayToObject } from "utils/object-util";

export const DashboardFilters = () => {
    const classes = loadsDashboardStyles();

    const { dashboardFilters } = useSelector(state => state.loadsDashboardState);
    const dispatch = useDispatch();
    const hasOneClaim = useSelector(userHasOneClient);
    let { data: lots, error: lotsError, isLoading: isLoadingLots } = useGetLotsQuery();
    let { data: clients, error: clientsError, isLoading: isLoadingClients } = useGetClientsQuery();
    let { data: transporters, error: transportersError, isLoading: isLoadingTransporters } = useGetTransportersQuery();
    let { data: clientsWithConfigs, error: clientsWithConfigsError, isFetching: isLoadingClientsWithConfigs } = useGetClientsWithConfigsQuery(null);
    let { data: clientTransporters, error: cTransportersError, isLoading: isLoadingCTransporters } = useGetClientTransportersQuery();

    let filteredClientConfigIds = clientsWithConfigs?.filter(client => (client.config.transportConfig.useTransport === true)).map(c => c.id);
    let clientAccounts = _.flatten(clients?.map(c => c.clientAccounts));
    clientAccounts = clientAccounts?.filter(c => filteredClientConfigIds?.includes(c.clientId));
    const clientLookup = arrayToObject(clientAccounts, 'id');

    const clientTransportersGrouped = groupBy(clientTransporters, 'clientId');

    const handleFilterChange = (key, value) => {
        const newFiletrs = { ...dashboardFilters, [key]: { value: value } };
        if (key == 'clientAccountId') {
            newFiletrs['clientId'] = { value: clientLookup?.[value]?.clientId };
            newFiletrs['pickupLocationId'] = { value: [] };
            newFiletrs['deliveryLocationId'] = { value: [] };
        }
        dispatch(setFilters(newFiletrs));
    }

    const onChangeDateFilter = (val, filterType = null) => {
        let item = getDateFilterRanges()?.[filterType ?? dashboardFilters?.['dateFilterType']?.value]?.find(f => f.id == +val);
        if (item) {
            const newFiletrs = {
                ...dashboardFilters,
                ['dateFilter']: { value: val },
                ['dateFilterType']: { value: filterType ?? dashboardFilters?.['dateFilterType']?.value },
                ['startDate']: { value: item.startDate?.toDateString() },
                ['endDate']: { value: item.endDate?.toDateString() }
            };
            dispatch(setFilters(newFiletrs));
        }
    }

    const onChangeDateFilterType = (val) => {
        onChangeDateFilter(1, val);
    }

    const getTransporterValues = () => {
        if (dashboardFilters?.['clientId']?.value == null)
            return transporters;
        else {
            let currentTransporterIds = clientTransportersGrouped[dashboardFilters?.['clientId']?.value]?.map(c => c.transporterId);
            return transporters?.filter(t => currentTransporterIds?.includes(t.id));
        }
    }

    return (<>
        <Grid container spacing={1} alignItems="center">
            <Grid item xs={12} className={classes.filtersWrapper}>
                <Grid item xs={4} className={classes.filterItem}>
                    <LotsDropdown
                        clientId={dashboardFilters?.['clientId']?.value}
                        title='Origin Lot'
                        identifier='lot'
                        values={lots}
                        onSelect={(val) => handleFilterChange('pickupLocationId', val)}
                        value={dashboardFilters?.['pickupLocationId']?.value}
                        showEmpty={true}
                    />
                </Grid>
                <Grid item xs={4} className={classes.filterItem}>
                    <LotsDropdown
                        clientId={dashboardFilters?.['clientId']?.value}
                        title='Destination Lot'
                        identifier='lot'
                        values={lots}
                        onSelect={(val) => handleFilterChange('deliveryLocationId', val)}
                        value={dashboardFilters?.['deliveryLocationId']?.value}
                        showEmpty={true}
                    />
                </Grid>
                {clientAccounts.length > 1 && <Grid item xs={4} className={classes.filterItem}>
                    <DropdownFilter
                        title='Client'
                        shrink
                        values={ hasOneClaim ? [{ id: '', name: 'All Accounts' }, ...clientAccounts.filter(c => !c.isDefault)] : [{ id: '', name: 'All clients' }, ...clientAccounts]}
                        onSelect={(val) => handleFilterChange('clientAccountId', +val)}
                        value={dashboardFilters?.['clientAccountId']?.value}
                    />
                </Grid>}
                <Grid item xs={4} className={classes.filterItem}>
                    <DropdownFilter
                        title='Carrier'
                        values={getTransporterValues()}
                        onSelect={(val) => handleFilterChange('carrierId', val)}
                        value={dashboardFilters?.['carrierId']?.value}
                        showEmpty
                    />
                </Grid>
                <Grid item xs={4} className={classes.filterItem}>
                    <DropdownFilter
                        title='Load Distance'
                        values={loadDistanceList}
                        onSelect={(val) => handleFilterChange('loadDistance', val)}
                        value={dashboardFilters?.['loadDistance']?.value}
                        showEmpty
                    />
                </Grid>
                <Grid item xs={4} className={classes.filterItem}>
                    <DropdownFilter
                        title='Filter Date by'
                        values={dateFilterTypesList}
                        onSelect={(val) => onChangeDateFilterType(val)}
                        value={dashboardFilters?.['dateFilterType']?.value}
                    />
                </Grid>
                <Grid item xs={4} className={classes.filterItem}>
                    <DropdownFilter
                        title='Latest Delivery Date'
                        values={getDateFilterRanges()?.[dashboardFilters?.['dateFilterType']?.value]}
                        onSelect={(val) => onChangeDateFilter(val)}
                        value={dashboardFilters?.['dateFilter']?.value}
                    />
                </Grid>
            </Grid>
        </Grid >
    </>
    )
}